import React from 'react'

const InnerLoader = () => <div className='innerloader-wrapper'>
    <div className='innerloader' />
</div>

export default InnerLoader